var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartiesReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.405 22.0388C35.0325 22.0388 33.8761 21.5559 32.9356 20.59C31.9952 19.6242 31.525 18.4677 31.525 17.1206C31.525 15.7735 31.9952 14.6298 32.9356 13.6894C33.8761 12.7489 35.0325 12.2787 36.405 12.2787C37.7776 12.2787 38.934 12.7489 39.8744 13.6894C40.8149 14.6298 41.2851 15.7735 41.2851 17.1206C41.2851 18.4677 40.8149 19.6242 39.8744 20.59C38.934 21.5559 37.7776 22.0388 36.405 22.0388ZM23.4043 22.0388C22.0572 22.0388 20.9008 21.5559 19.9349 20.59C18.9691 19.6242 18.4862 18.4677 18.4862 17.1206C18.4862 15.7735 18.9691 14.6298 19.9349 13.6894C20.9008 12.7489 22.0572 12.2787 23.4043 12.2787C24.7514 12.2787 25.8952 12.7489 26.8356 13.6894C27.776 14.6298 28.2462 15.7735 28.2462 17.1206C28.2462 18.4677 27.776 19.6242 26.8356 20.59C25.8952 21.5559 24.7514 22.0388 23.4043 22.0388ZM23.4043 25.2413C24.8023 25.2413 26.34 25.4446 28.0175 25.8513C29.695 26.258 31.2454 26.9188 32.6688 27.8338C34.0921 28.7488 34.8038 29.7909 34.8038 30.9601V35.0014H12.0049V30.9601C12.0049 29.7909 12.7038 28.7488 14.1018 27.8338C15.4997 26.9188 17.0501 26.258 18.7531 25.8513C20.456 25.4446 22.0064 25.2413 23.4043 25.2413ZM36.405 25.2413C37.8284 25.2413 39.3788 25.4446 41.0563 25.8513C42.7338 26.258 44.2716 26.9188 45.6695 27.8338C47.0674 28.7488 47.7664 29.7909 47.7664 30.9601V35.0014H38.0063V30.9601C38.0063 28.7742 36.9388 26.8934 34.8038 25.3176C35.4646 25.2667 35.9984 25.2413 36.405 25.2413Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartiesReport);
export default __webpack_public_path__ + "static/media/parties-report.d0c6fc045279377817d45cc21eed1e9d.svg";
export { ForwardRef as ReactComponent };